import { $t } from '../../composables/i18n'
import { Codebook } from '../Codebook'

export enum NtakLocalTaxExemptionId {
  UNDER_18 = 1,
  MEDICAL_OR_SOCIAL_INSTITUTION = 2,
  STUDENT_OR_TRAINEE = 3,
  SERVICE_DUTY = 4,
  OFFICIAL_OR_COURT_MEASURE = 5,
  LOCAL_BUSINESS_WORK = 6,
  TEMPORARY_BUSINESS_ACTIVITY = 7,
  LOCAL_HOLIDAY_PROPERTY_OWNER = 8,
  ECCLESIASTICAL_PERSON = 9,
  LOCAL_RESIDENT = 10,
  MUNICIPAL_DECREE_OTHER = 11,
}

export class NtakLocalTaxExemption extends Codebook<NtakLocalTaxExemptionId> {
  static readonly UNDER_18 = new NtakLocalTaxExemption(NtakLocalTaxExemptionId.UNDER_18, () =>
    $t('Guest under 18 years of age'),
  )

  static readonly MEDICAL_OR_SOCIAL_INSTITUTION = new NtakLocalTaxExemption(
    NtakLocalTaxExemptionId.MEDICAL_OR_SOCIAL_INSTITUTION,
    () => $t('Stay in a medical, inpatient care or social institution'),
  )

  static readonly STUDENT_OR_TRAINEE = new NtakLocalTaxExemption(
    NtakLocalTaxExemptionId.STUDENT_OR_TRAINEE,
    () => $t('Pupil, student in secondary or higher education, or vocational trainee'),
  )

  static readonly SERVICE_DUTY = new NtakLocalTaxExemption(
    NtakLocalTaxExemptionId.SERVICE_DUTY,
    () => $t('Guest performing a service duty'),
  )

  static readonly OFFICIAL_OR_COURT_MEASURE = new NtakLocalTaxExemption(
    NtakLocalTaxExemptionId.OFFICIAL_OR_COURT_MEASURE,
    () => $t('Guest staying due to an official or court measure'),
  )

  static readonly LOCAL_BUSINESS_WORK = new NtakLocalTaxExemption(
    NtakLocalTaxExemptionId.LOCAL_BUSINESS_WORK,
    () => $t('Entrepreneur or employee working for a business based in the settlement'),
  )

  static readonly TEMPORARY_BUSINESS_ACTIVITY = new NtakLocalTaxExemption(
    NtakLocalTaxExemptionId.TEMPORARY_BUSINESS_ACTIVITY,
    () => $t('Entrepreneur or employee carrying out temporary business activity'),
  )

  static readonly LOCAL_HOLIDAY_PROPERTY_OWNER = new NtakLocalTaxExemption(
    NtakLocalTaxExemptionId.LOCAL_HOLIDAY_PROPERTY_OWNER,
    () =>
      $t(
        'Owner or tenant of a holiday property in the settlement, housing cooperative member or their relative',
      ),
  )

  static readonly ECCLESIASTICAL_PERSON = new NtakLocalTaxExemption(
    NtakLocalTaxExemptionId.ECCLESIASTICAL_PERSON,
    () => $t('Ecclesiastical person staying in a building or plot owned by the church'),
  )

  static readonly LOCAL_RESIDENT = new NtakLocalTaxExemption(
    NtakLocalTaxExemptionId.LOCAL_RESIDENT,
    () => $t('Guest with a residence or place of stay in the settlement'),
  )

  static readonly MUNICIPAL_DECREE_OTHER = new NtakLocalTaxExemption(
    NtakLocalTaxExemptionId.MUNICIPAL_DECREE_OTHER,
    () => $t('Exemption granted by municipal decree (other)'),
  )

  private constructor(
    id: NtakLocalTaxExemptionId,
    public readonly name: () => string,
  ) {
    super(id)
  }
}
